module.exports = __webpack_public_path__ + "static/media/ridefrica.c2303982.jpg";